import { PieceName } from "../../board-logic/piece";
import { JSONBoardState } from "../../board-logic/board/board-state";

/**
 * Each tutorial move contains a board state and a board move [from, to]
 *
 */
type TutMove = {
  state: JSONBoardState;
  move: [string, string];
};

/**
 * Each 'PieceTutorial' contains a description of the piece
 * and array of Tutorial Moves
 */
type PieceTutorial = {
  name: string;
  desc: string;
  moves: TutMove[];
};

/**
 * A JS dictionary where the Key is Piece name
 * and value is a 'PieceTutorial'
 */
export const pieceTutorials: Record<PieceName, PieceTutorial> = {
  KING: {
    name: "ER KING",
    desc: "Er King muove di una casella in ogni direzione. Semplice.<br /><br />Il tuo King è Mongolius, il difensore dell'umanità, mentre il King avversario è Berlusconomon, il peggio di tutti!",
    moves: [
      {
        state: [{ lastMove: null, pieces: [["C3", "WHITE", "KING"]] }],
        move: ["C3", "C4"],
      },
    ],
  },

  CHARIOT: {
    name: "LO SMILZO",
    desc: "Lo Smilzo muove fino a 3 caselle in verticale, e quante jene pare in orizzontale.<br /><br />Skrotomon è il tuo Smilzo, dall'altra parte c'è Biceppamon.",
    moves: [
      {
        state: [{ lastMove: null, pieces: [["A1", "WHITE", "CHARIOT"]] }],
        move: ["A1", "A4"],
      },
      {
        state: [{ lastMove: null, pieces: [["A4", "WHITE", "CHARIOT"]] }],
        move: ["A4", "E4"],
      },
    ],
  },

  ARCHER: {
    name: "ER CEPPA",
    desc: "Er Ceppa muove fino a 2 caselle in diagonale.<br /><br />Può scavalcare gli altri Stronzemon, come il cavallo negli scacchi.<br /><br />Er Ceppa che gestisci è Pornomon, la sua controparte è Sorkadepollomon.",
    moves: [
      {
        state: [
          {
            lastMove: null,
            pieces: [["C3", "WHITE", "ARCHER"]],
          },
        ],
        move: ["C3", "E5"],
      },
      {
        state: [
          {
            lastMove: null,
            pieces: [
              ["C3", "WHITE", "ARCHER"],
              ["E5", "BLACK", "KING"],
              ["D4", "BLACK", "TOWER"],
            ],
          },
        ],
        move: ["C3", "E5"],
      },
    ],
  },

  MAGICIAN: {
    name: "ER MAGGICO",
    desc: "Er Maggico và dove je pare, quanto je pare.<br /><br />Non può catturare nessuno, ma può scambiare di posto con un altro Stronzemon qualsiasi.<br /><br />Il tuo Maggico è Bocchinomon, quello avversario è Bruttinculomon.",
    moves: [
      {
        state: [
          {
            lastMove: null,
            pieces: [
              ["C1", "WHITE", "TOWER"],
              ["C3", "WHITE", "MAGICIAN"],
            ],
          },
        ],
        move: ["C3", "C1"],
      },
      {
        state: [
          {
            lastMove: null,
            pieces: [
              ["C3", "BLACK", "KING"],
              ["E1", "WHITE", "MAGICIAN"],
            ],
          },
        ],
        move: ["E1", "C3"],
      },
    ],
  },

  SPY: {
    name: "L'INFAME",
    desc: "L'Infame muove di una casella in ogni direzione, come er King.<br /><br />Se si trova sul bordo, l'Infame può spostarsi in una casella opposta del tabellone.<br /><br/> Il tuo Infame è Emorroidomon, e dovrà tenere testa a Ceppaseccamon!",
    moves: [
      { state: [{ lastMove: null, pieces: [["C2", "WHITE", "SPY"]] }], move: ["C2", "C1"] },
      { state: [{ lastMove: null, pieces: [["C1", "WHITE", "SPY"]] }], move: ["C1", "C5"] },
      {
        state: [
          {
            lastMove: null,
            pieces: [
              ["A1", "WHITE", "SPY"],
              ["E5", "BLACK", "KING"],
            ],
          },
        ],
        move: ["A1", "E5"],
      },
    ],
  },

  TOWER: {
    name: "ER GROSSO",
    desc: "Er Grosso muove di una casella in verticale o orizontale.<br /><br />Er Grosso non può catturare né esse catturato. Usalo come scudo.<br /><br />Il tuo Grosso è Porcomon, mentre il Grosso avversario è Leccamelomon.",
    moves: [
      {
        state: [
          {
            lastMove: null,
            pieces: [
              ["B3", "WHITE", "KING"],
              ["C2", "WHITE", "TOWER"],
              ["E3", "BLACK", "CHARIOT"],
            ],
          },
        ],
        move: ["C2", "C3"],
      },
      {
        state: [
          {
            lastMove: null,
            pieces: [
              ["B3", "WHITE", "KING"],
              ["C3", "WHITE", "TOWER"],
              ["E3", "BLACK", "CHARIOT"],
            ],
          },
          {
            lastMove: ["C2", "C3"],
            pieces: [
              ["B3", "WHITE", "KING"],
              ["C3", "WHITE", "TOWER"],
              ["E3", "BLACK", "CHARIOT"],
            ],
          },
        ],
        move: ["E3", "D3"],
      },
    ],
  },
};
